var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShower(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 11C13.837 11 13.2011 11.2634 12.7322 11.7322C12.2634 12.2011 12 12.837 12 13.5V21.5C12 21.7761 11.7761 22 11.5 22C11.2239 22 11 21.7761 11 21.5V13.5C11 12.5717 11.3687 11.6815 12.0251 11.0251C12.6815 10.3687 13.5717 10 14.5 10C15.4283 10 16.3185 10.3687 16.9749 11.0251C17.5122 11.5625 17.8568 12.2566 17.9641 13H18C19.1046 13 20 13.8954 20 15V16C20.5523 16 21 16.4477 21 17C21 17.5523 20.5523 18 20 18H15C14.4477 18 14 17.5523 14 17C14 16.4477 14.4477 16 15 16V15C15 13.9123 15.8683 13.0274 16.9496 13.0006C16.8524 12.5237 16.6171 12.0816 16.2678 11.7322C15.7989 11.2634 15.163 11 14.5 11ZM19 15V16H16V15C16 14.4477 16.4477 14 17 14H18C18.5523 14 19 14.4477 19 15Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19C15.2239 19 15 19.2239 15 19.5V20.5C15 20.7761 15.2239 21 15.5 21C15.7761 21 16 20.7761 16 20.5V19.5C16 19.2239 15.7761 19 15.5 19Z",
    fill: "#00112B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.5C17 19.2239 17.2239 19 17.5 19C17.7761 19 18 19.2239 18 19.5V20.5C18 20.7761 17.7761 21 17.5 21C17.2239 21 17 20.7761 17 20.5V19.5Z",
    fill: "#00112B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19C19.2239 19 19 19.2239 19 19.5V20.5C19 20.7761 19.2239 21 19.5 21C19.7761 21 20 20.7761 20 20.5V19.5C20 19.2239 19.7761 19 19.5 19Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShower);
export default __webpack_public_path__ + "static/media/shower.2844e2de9dcb8ea5853305d49ab7b7f5.svg";
export { ForwardRef as ReactComponent };